import React from "react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/landingContent";
export function AuthorNoteSection() {
  return <section className="bg-blush px-4 py-14 sm:py-20" aria-labelledby="author-title" data-id="element-71" data-mp="3oywwv2fbimxn">
      <div className="mx-auto grid max-w-5xl grid-cols-1 items-start gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-12" data-id="element-72" data-mp="3tw56ufqbbknt">
        <img src={images.author} alt="Dr. Karito in her clinic" className="mx-auto aspect-[4/5] w-full max-w-sm rounded-3xl object-cover object-top shadow-xl md:sticky md:top-8" data-id="element-73" data-mp="2p2gfqiatien" />
        <div data-id="element-74" data-mp="gj3iou8glnjr">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-rose sm:text-sm" data-id="element-75" data-mp="gijy15rfcl21">A personal note from Dr. Karito</p>
          <h2 id="author-title" className="mt-3 font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-76" data-mp="lgljfxcbowgo">
            Why I created Menopause Decision Map™
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-77" data-mp="vh5nf7r88f2l">
            <p data-id="element-78" data-mp="6xsrvlom4xea">
              I created Menopause Decision Map™ because I wanted to address a practical challenge in menopause care:
              having access to medical information is not always the same as having an organized way to use it during a
              consultation.
            </p>
            <p data-id="element-79" data-mp="3p3e2yur1n1zt">
              Menopause assessment can involve a wide range of symptoms, medical histories, risk factors, treatment
              considerations, and patient preferences. Even when you have the necessary knowledge, organizing all these
              elements during a busy clinical day can be challenging.
            </p>
            <p data-id="element-80" data-mp="fweim448niq5">
              That's why I developed this collection of visual decision maps, assessment references, checklists, and
              consultation tools. My goal is to help you organize the information you need, structure your clinical
              reasoning, and approach consultations with a clearer process.
            </p>
            <p data-id="element-81" data-mp="2xvdvt48fz6qo">
              I don't believe a visual map can replace a physician's experience or the need to evaluate each patient
              individually. I believe that well-organized resources can help make complex information easier to navigate.
            </p>
            <p data-id="element-82" data-mp="2o5ayiruaf6mj">Thank you for allowing me to be part of your professional journey.</p>
            <p className="font-serif text-3xl font-bold italic text-plum" data-id="element-83" data-mp="2t3306dkqi73x">Dr. Karito</p>
          </div>
        </div>
      </div>
      <CtaButton className="mt-10" label="Start organizing my consultations" data-id="element-84" data-mp="2f790ml5uou3h" />
    </section>;
}